var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('span',[_vm._v("\n    COPYRIGHT @ "+_vm._s(new Date().getFullYear())+"\n    "),_c('a',{attrs:{"href":"https:/www.evogerencial.com.br","target":"_blank","rel":"nofollow"}},[_vm._v("BTX")]),_vm._v(", All rights Reserved\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }